var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pb-5"},[_c('div',{staticClass:"mt-5 d-flex flex-column align-items-center"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mt-3 text-center"},[_vm._v(" "+_vm._s(_vm.detail)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }